import { useQuery } from "react-query";
import { AuthorizedService } from "shared/axios";
import { INSTALLATION_DATA_REFETCH_INTERVAL } from "utils/global/constants";

export const INSTRUCTION_SUMMARY_QUERY_KEY = "instruction-summary";
const END_POINT = "/installation/instruction-summary";

export type SummaryItem = { code: string; net: number };

type InstructionSummaryParams = {
  combinedSignMode?: boolean;
  acceptOrder?: string;
  rejectOrder?: string;
  failedOrder?: string;
  requestApproval?: string;
  permitGranted?: string;
  approvalSubmittedByCustomer?: string;
  installationProtocol?: string;
  sendDocumentsToCustomer?: string;
  draftCreated?: string;
  sendInvoice?: string;
  invoiceReminded?: string;
  invoicePaid?: string;
  closeOrder?: string;
  erectSigns?: string;
  collectSigns?: string;
  excludeEmail?: string;
  includeEmail?: string;
  noSignInstallation?: string;
  withPermission?: string;
  search?: string;
  setupDateStart?: string;
  setupDateEnd?: string;
  pickupDateStart?: string;
  pickupDateEnd?: string;
};

export const useInstructionSummary = (
  params: InstructionSummaryParams,
  enabled = false,
) => {
  return useQuery<SummaryItem[]>({
    queryKey: [INSTRUCTION_SUMMARY_QUERY_KEY, params],
    queryFn: async () => {
      const res = await new AuthorizedService().get(END_POINT, params);
      return res.data;
    },
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: INSTALLATION_DATA_REFETCH_INTERVAL,
  });
};
